// extracted by mini-css-extract-plugin
export default {"wrapper":"image-placeholder-module--wrapper--9337f"};